<template>
  <div class="hello">
      <div class='container'>
            <transition name="fade">
                <div v-if="addingFile" class="loading">
                    <p>Uploading Image...</p>
                </div>
            </transition>
        </div>

        <!-- Error modal if not image type -->
        <b-modal id="modal-error" ok-only title="Error" ok-title="OK">
            {{errMsg}}
        </b-modal>

        <!-- Modal item added -->
        <b-modal id="modal-itemadded" ok-only title="Success" ok-title="OK" @ok="endAddItem">
            {{theSaleItem.title}} is on sale now
        </b-modal>


    <b-container>
        <b-row>
            <b-col>
                <h4 style="margin-top:20px">Add An Item For Sale</h4>
            </b-col>
        </b-row>
        <!-- Title -->
        <b-row>
            <b-col>
                <b-input-group prepend="Title" class="mt-3">
                    <b-form-input v-model="theSaleItem.title" placeholder="Add a Title"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Price -->
        <b-row>
            <b-col>
                <b-input-group prepend="Price $" class="mt-3">
                    <b-form-input v-model="theSaleItem.price" placeholder="Numbers Only"></b-form-input>
                </b-input-group>
            </b-col>
        </b-row>

        <!-- Description -->
        <b-row>
            <b-col>
                <b-form-group style="margin-top:20px" class="mb-0" label-for="textarea-formatter" description="Details of this item">
                    <b-form-textarea
                        id="textarea-formatter"
                        v-model="theSaleItem.description"
                        placeholder="Add a description"
                    ></b-form-textarea>
                </b-form-group>
            </b-col>
        </b-row>

        <!-- Images -->
        <b-row>
            <b-col>
                <h6 style="margin-top:20px">Add Up To 6 Images</h6>
            </b-col>
        </b-row>

        <!-- Camera button -->
        <!-- Logo -->
        <b-row>
            <!-- Image 1 -->
            <b-card style="width: 300px; margin:10px; ">
                <input id="image1"  @change="onLogoFileChanged($event, 'image1')"  type="file" hidden>
                <div style="height:110px; text-align: center;  margin-bottom:10px">
                    <img v-if="theSaleItem.imagethumburl1" @click="chooseFiles($event, 'image1')" style="cursor: pointer;" height="100px" :src="theSaleItem.imagethumburl1"/>
                    <b-button size="lg" v-else @click="chooseFiles($event, 'image1')"><font-awesome-icon icon="camera" /> </b-button>
                </div>
            </b-card>

                <!-- Image 2 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image2"  @change="onLogoFileChanged($event, 'image2')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="theSaleItem.imagethumburl2" @click="chooseFiles($event, 'image2')" style="cursor: pointer;" height="100px" :src="theSaleItem.imagethumburl2"/>
                        <b-button size="lg" v-else @click="chooseFiles($event, 'image2')"><font-awesome-icon icon="camera" /> </b-button>
                    </div>
                </b-card>

                <!-- Image 3 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image3"  @change="onLogoFileChanged($event, 'image3')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="theSaleItem.imagethumburl3" @click="chooseFiles($event, 'image3')" style="cursor: pointer;" height="100px" :src="theSaleItem.imagethumburl3"/>
                        <b-button size="lg" v-else @click="chooseFiles($event, 'image3')"><font-awesome-icon icon="camera" /> </b-button>
                    </div>
                </b-card>

                <!-- Image 4 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image4"  @change="onLogoFileChanged($event, 'image4')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="theSaleItem.imagethumburl4" @click="chooseFiles($event, 'image4')" style="cursor: pointer;" height="100px" :src="theSaleItem.imagethumburl4"/>
                        <b-button size="lg" v-else @click="chooseFiles($event, 'image4')"><font-awesome-icon icon="camera" /> </b-button>
                    </div>
                </b-card>

                <!-- Image 5 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image5"  @change="onLogoFileChanged($event, 'image5')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="theSaleItem.imagethumburl5" @click="chooseFiles($event, 'image5')" style="cursor: pointer;" height="100px" :src="theSaleItem.imagethumburl5"/>
                        <b-button size="lg" v-else @click="chooseFiles($event, 'image5')"><font-awesome-icon icon="camera" /> </b-button>
                    </div>
                </b-card>

                <!-- Image 6 -->
                <b-card style="width: 300px; margin:10px; ">
                    <input id="image6"  @change="onLogoFileChanged($event, 'image6')"  type="file" hidden>
                    <div style="height:110px; text-align: center;  margin-bottom:10px">
                        <img v-if="theSaleItem.imagethumburl6" @click="chooseFiles($event, 'image6')" style="cursor: pointer;" height="100px" :src="theSaleItem.imagethumburl6"/>
                        <b-button size="lg" v-else @click="chooseFiles($event, 'image6')"><font-awesome-icon icon="camera" /> </b-button>
                    </div>
                </b-card>
        </b-row>

        <!-- Add Item Button -->
        <b-row>
            <b-col>
                <b-button variant="success" @click="addItem()">Add Item</b-button>
            </b-col>
        </b-row>
        
    </b-container>
    <div id="footerid">
        <footer><pagefooter/></footer>
    </div>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')
import Pagefooter from '../Pagefooter'
import axios from 'axios'

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'createdItemForSale'])
    },

    components: {
        Pagefooter,
    },

    data() {
        return {
            errMsg:'',
            title:'',
            description:'',
            price:'',
            itemid:'',
            imageurl1:'',
            imageurl2:'',
            imageurl3:'',
            imageurl4:'',
            imageurl5:'',
            imageurl6:'',
            imagethumburl1:'',
            imagethumburl2:'',
            imagethumburl3:'',
            imagethumburl4:'',
            imagethumburl5:'',
            imagethumburl6:'',
            theSaleItem:{
                title:'',
                description:'',
                price:'',
                itemid:'',
                imageurl1:'',
                imageurl2:'',
                imageurl3:'',
                imageurl4:'',
                imageurl5:'',
                imageurl6:'',
                imagethumburl1:'',
                imagethumburl2:'',
                imagethumburl3:'',
                imagethumburl4:'',
                imagethumburl5:'',
                imagethumburl6:'',
                createdOn:'',
                active:1,
                sold:0,
                views:0,
                messages:0,
            },
            addingFile:false,
            cloudinary: {
                logoFullPreset:'forsalefullimage',
                logoThumbPreset:'forsalethumbnailimage',
                apiKey: '629997215451183',
                cloudName: 'lo4xxr5lr',
                uploadURL:'https://api.cloudinary.com/v1_1/lo4xxr5lr/upload'
            }, 

        }
    },

    methods:{

        //Choose image files
        chooseFiles(event, imagenumber) {
            console.log("Choosing image")
            document.getElementById(imagenumber).click()
            
        },

        //Image file changed
        onLogoFileChanged (event, imagenumber) {
            console.log("File changed: " + imagenumber)
            this.selectedFile = event.target.files[0]
            const name = event.target.files[0].name;
            const lastDot = name.lastIndexOf('.');

            this.fileName = name.substring(0, lastDot);
            this.fileExtension = name.substring(lastDot + 1);

            console.log(this.fileName, this.fileExtension)

            //Check file extention
            this.fileExtension=this.fileExtension.toLowerCase()
            if(this.fileExtension!='jpg'&&this.fileExtension!='jpeg'&&this.fileExtension!='png'){
                this.errMsg="Image must be a JPEG or PNG"
                this.$bvModal.show("modal-error")
                return
            }
            this.uploadLogotoCloudinary(imagenumber)
        },

        //Upload file
        uploadLogotoCloudinary(imagenumber){
            this.addingFile = true
            let data = new FormData();
            data.append('file', this.selectedFile); 
            data.append('upload_preset', this.cloudinary.logoThumbPreset);

            axios
                .post(this.cloudinary.uploadURL, data)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL main: " + result.data.secure_url)
                        if(imagenumber=='image1') this.theSaleItem.imageurl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.theSaleItem.imageurl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.theSaleItem.imageurl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.theSaleItem.imageurl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.theSaleItem.imageurl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.theSaleItem.imageurl6 = result.data.secure_url
                    }
                    this.addingFile = false

                })
                .catch((err) => {
                    console.log('Ax Error:' + err);
                    
                    this.addingFile = false
                }) 

            let thumbdata = new FormData();
            thumbdata.append('file', this.selectedFile); 
            thumbdata.append('upload_preset', this.cloudinary.logoFullPreset);

            //Add thumbnail
            axios
                .post(this.cloudinary.uploadURL, thumbdata)
                .then((result) => {
                    if(result.data.secure_url){
                        console.log("URL thumbnail: " + result.data.secure_url)
                        //Add thumbnail url
                        if(imagenumber=='image1') this.theSaleItem.imagethumburl1 = result.data.secure_url
                        else if(imagenumber=='image2') this.theSaleItem.imagethumburl2 = result.data.secure_url
                        else if(imagenumber=='image3') this.theSaleItem.imagethumburl3 = result.data.secure_url
                        else if(imagenumber=='image4') this.theSaleItem.imagethumburl4 = result.data.secure_url
                        else if(imagenumber=='image5') this.theSaleItem.imagethumburl5 = result.data.secure_url
                        else if(imagenumber=='image6') this.theSaleItem.imagethumburl6 = result.data.secure_url
                    }
                    this.addingFile = false
                })
                .catch((err) => {
                    console.log('Ax Thumb Error:' + err);
                    this.addingFile = false
                })

            },

        addItem(){
            console.log("Adding Item")

            //Check for errors
            if(this.theSaleItem.title.length<4){
                this.errMsg="Enter at least 4 characters for the title"
                this.$bvModal.show("modal-error")
                return
            }
            if(isNaN(this.theSaleItem.price)||!this.theSaleItem.price){
                this.errMsg="Enter a valid price, numbers only"
                this.$bvModal.show("modal-error")
                return
            }
            if(this.theSaleItem.description.length<10){
                this.errMsg="Enter at least 10 characters for description"
                this.$bvModal.show("modal-error")
                return
            }

            this.theSaleItem.company = this.userProfile.company
            this.theSaleItem.createdOn = new Date()
            this.theSaleItem.uid = this.currentUser.uid
            this.theSaleItem.city = this.userProfile.city
            this.theSaleItem.county = this.userProfile.county
            this.theSaleItem.state = this.userProfile.state
            this.theSaleItem.breweryurl = 'https://kegseeker.com/#/brewers/'+this.userProfile.shortName
            this.theSaleItem.street1 = this.userProfile.street1
            this.theSaleItem.street2 = this.userProfile.street2
            this.theSaleItem.email = this.currentUser.email

            fb.forSaleCollection.add(this.theSaleItem)
            //Empty sale item
            this.$store.commit('setCreatedItemForSale',null)

            this.$bvModal.show("modal-itemadded")

        },
        //End item and go back
        endAddItem(){
            this.$router.push('/myitemsforsale')
        },

    },

    mounted(){
        //Create item id
        var min=1111111111111111
        var max=9999999999999999
        var randomId = Math.floor(Math.random() * (+max - +min)) + +min; 
        var randomIdString = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        this.itemid = randomIdString
        
        if(this.createdItemForSale) this.theSaleItem = this.createdItemForSale
        this.theSaleItem.id=randomIdString
    },
}
</script>

